<ion-header>
  <ion-toolbar>
    <ion-title>
      <img src="assets/icon/publish-targets/facebook.png" alt="Facebook" style="height: 24px; vertical-align: middle; margin-right: 8px;" />
      Edit Facebook Post
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">Cancel</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; margin: 24px 16px 8px 16px;">
    <img src="assets/icon/publish-targets/facebook.png" alt="Facebook" style="height: 40px;" />
    <ion-button fill="clear" color="primary" (click)="viewPost()" style="font-size: 14px;">
      <ion-icon name="open-outline" slot="start"></ion-icon>
      View on Facebook
    </ion-button>
  </div>
  <ion-item>
    <ion-textarea [(ngModel)]="editedText" fill="solid" autoGrow="true"></ion-textarea>
  </ion-item>
</ion-content>

<ion-footer class="ion-padding">
  <ion-button expand="block" color="primary" (click)="save()">Save</ion-button>
</ion-footer>